document.addEventListener('DOMContentLoaded', function(event) {
    document.querySelectorAll('.wysiwyg-area iframe').forEach((iframe) => {
        const src = iframe.getAttribute('src')
        const players = ['www.youtube.com', 'player.vimeo.com']

        if (new RegExp(players.join('|')).test(src)) {
            const wrapper = document.createElement('div')
            wrapper.classList.add('ratio', 'ratio-16x9')

            iframe.parentNode.insertBefore(wrapper, iframe)
            wrapper.appendChild(iframe)
        }
    })
})